import { Either, Left, Right } from 'fp-ts/lib/Either'
import { Response } from 'superagent'

import { log } from '@/log'
import { ApiClient } from './client'

const namespace: string = 'atone'

export class Atone {
  static async createChecksum(info: AtonePayment): Promise<Either<Error, Response>> {
    const payload = JSON.stringify(info)

    try {
      const response = await ApiClient
        .post(`/api/atone/checksum`)
        .send({ info : payload })

      log.debug({ service: `${namespace}/createChecksum`, response })

      return new Right(response)
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }
}

export interface AtonePayment {
  amount: number,
  shop_transaction_no: string, // 加盟店取引ID（Engineから取得した仮sales_order_id）1回ずつ変えてください
  user_no: string, // ユーザID
  sales_settled: false, // 売上確定フラグ：固定でfalse
  customer: AtonePaymentCustomer,
  dest_customers: AtonePaymentDelivery[],
  items: AtonePaymentItem[],
}

export interface AtonePaymentCustomer {
  customer_name: string,
  customer_family_name: string,
  customer_given_name: string,
  customer_name_kana: string,
  customer_family_name_kana: string,
  customer_given_name_kana: string,
  birthday: string,
  sex_division: number,
  zip_code: string,
  address: string,
  tel: string,
  email: string,
}

export interface AtonePaymentDelivery {
  dest_customer_name: string,
  // Phonetic name for delivery does not exist in mycolor.
  dest_customer_name_kana?: string,
  dest_zip_code: string,
  dest_address: string,
  dest_tel: string,
}

export interface AtonePaymentItem {
  shop_item_id: string,
  item_name: string,
  item_price: number,
  item_count: number,
  item_url: string,
}
